import {KebabHorizontalIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

export function HunkKebabIcon({isSplit}: {isSplit: boolean}) {
  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className={clsx('hunk-kebab-icon pr-2 pb-1', !isSplit && 'hunk-kebab-icon-unified')}>
      <KebabHorizontalIcon />
    </div>
  )
}
